import { supabase } from './supabase'

// Calls Claude through our Netlify function. The function only answers
// signed-in staff, so we send the current Supabase session token.
export async function callClaude(body) {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) throw new Error('Your session expired. Please sign in again.')

  const res = await fetch('/.netlify/functions/claude-proxy', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok || data.error) {
    const msg = typeof data.error === 'string' ? data.error : data.error?.message
    throw new Error(msg || `Request failed (${res.status})`)
  }
  return data
}

// Joins all text blocks of a Claude response.
export function responseText(data) {
  return (data?.content || []).filter(b => b.type === 'text').map(b => b.text).join('')
}

// Pulls the first JSON object out of a Claude text response.
export function parseJsonResponse(data) {
  const match = responseText(data).match(/\{[\s\S]*\}/)
  if (!match) throw new Error('Could not read the AI response')
  return JSON.parse(match[0])
}
